<template>
  <div class="Process">
    <Header msg='报读流程'/>
    <img src="@/assets/mine/bg_pay@3x.png" class="Process-img"/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'Process',
  components: {
    Header
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
  .Process{
    min-height: 100vh;
    font-size: 0;
    .Process-img{
        width: 100%;
        margin-top: 0.44rem;
    }
  }
</style> 

